var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.warning)?_c('div',[_c('v-alert',{attrs:{"outlined":"","dense":"","type":"warning","border":"left","dismissible":""}},[_vm._v(" Your session is about to expire. You will be logged out in 60 seconds. ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }